var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      attrs: {
        cardClass: "rounded-lg border border-gray-300 fullWidthCardRes",
        footerPadding: "px-0",
      },
    },
    [
      _c(
        "div",
        { staticClass: "w-full flex flex-col p-4 pb-0" },
        [
          _c("div", [
            _c("div", { staticClass: "flex flex-row justify-between pb-2" }, [
              _c(
                "div",
                { staticClass: "flex flex-row gap-2 ml-auto" },
                [
                  _c("UiButton", {
                    staticClass: "mb-0.5",
                    attrs: {
                      buttonText: "Remove access",
                      variant: "outline",
                      buttonClasses: "customButtonSmall",
                    },
                    on: { click: _vm.removeAccess },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "flex w-full justify-center h-fit" },
              [
                _c(
                  "RouterLink",
                  { attrs: { to: _vm.managerRouteParams } },
                  [
                    _c("ResourceAvatar", {
                      staticClass: "cursor-pointer text-primary-500",
                      attrs: {
                        image: _vm.avatar,
                        initial: _vm.managerInitials,
                        avatarClasses: "h-8 w-8",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex items-center justify-center pt-2 flex-col" },
              [
                _c("a", { attrs: { href: _vm.managerHref } }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "font-medium text-lg mb-1 text-default-500 hover:text-primary-500 blueText flex flex-row items-center cursor-pointer gap-2",
                    },
                    [
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.managerFullName) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flag-wrapper" },
                        [
                          _vm.country
                            ? _c("country-flag", {
                                staticClass: "country-flag",
                                attrs: { country: _vm.country, size: "small" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center text-default-500 text-base font-normal",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.managerJobTitle ? _vm.managerJobTitle : "n/a"
                        ) +
                        " "
                    ),
                  ]
                ),
                _vm.managerLocation
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-center text-default-grey text-sm font-medium mb-3",
                      },
                      [_vm._v(" " + _vm._s(_vm.managerLocation) + " ")]
                    )
                  : _vm._e(),
                _vm._t("default"),
              ],
              2
            ),
          ]),
          _vm._t("secondary"),
          _c("ActionSection", {
            attrs: {
              actionObject: _vm.getActionSectionValues,
              currentUser: _vm.currentUser,
              manager: _vm.manager,
            },
          }),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex gap-1 w-full skills-footer items-start items-center px-4",
            },
            [
              _vm._v(" Skills: "),
              _vm.skills.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex flex-row gap-1 items-center" },
                    [
                      _vm._l(_vm.skills.slice(0, 3), function (skill) {
                        return _c(
                          "div",
                          { key: skill.skill.name, staticClass: "skills-chip" },
                          [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                        )
                      }),
                      _vm.skills.length > 3
                        ? _c("div", [
                            _c("div", { staticClass: "skills-chip-plus" }, [
                              _vm._v("+" + _vm._s(_vm.skills.length - 3)),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.skills.length === 0 || _vm.skills === undefined
                ? _c("div", [_vm._v("n/a")])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }